import CircleIcon from "@mui/icons-material/Brightness1";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";
const CustomWarningCircleIcon = ({ ...props }) => {
  return (
    <CircleIcon
      sx={{
        color: "warning",
        size: 2,
      }}
      {...props}
    />
  );
};

const steps = [
  "New",
  // 'Hold',
  "Initial Review",
  "Final Review",
  "To Notify",
  "Close",
  "Funded",
];
function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, error, className } = props;
  // console.log("ColorlibStepIcon className ==>", className);
  //className explode /, 0 is className, 1 is isWaitProcess
  let classNameArr = className.split("/");
  let classNameLabel = classNameArr[0];
  let isWaitProcess = classNameArr[1];
  // console.log("ColorlibStepIcon classNameLabel ==>", classNameLabel);
  // console.log("ColorlibStepIcon isWaitProcess ==>", isWaitProcess);
  // console.log("ColorlibStepIcon active ==>", classNameLabel, isWaitProcess);
  if (error) {
    return <CircleIcon color="error" sx={{ size: 2 }} />;
  } else if (completed) {
    return <CircleIcon color="disabled" sx={{ size: 2 }} />;
  } else if (active) {
    if (
      classNameLabel == "Initial Review" ||
      classNameLabel == "restart" ||
      classNameLabel == "Final Review" ||
      classNameLabel == "To Notify"
    ) {
      // initial review, need banker action, so always show primary color
      if (classNameLabel == "To Notify" && isWaitProcess == "yes") {
        return <CircleIcon color="warning" sx={{ size: 20 }} />;
      } else {
        return <CircleIcon color="primary" sx={{ size: 2 }} />;
      }
    } else if (
      // classNameLabel == "To Notify" ||
      classNameLabel == "Approved" ||
      classNameLabel == "Pre-Approved" ||
      classNameLabel == "pre-approve" ||
      classNameLabel == "Countered" ||
      classNameLabel == "Completed" ||
      classNameLabel == "Close"
      // classNameLabel == "Funded"
    ) {
      if (isWaitProcess == "yes") {
        return <CircleIcon color="warning" sx={{ size: 20 }} />;
      } else if (isWaitProcess == "executing") {
        return <CircleIcon color="primary" sx={{ size: 2 }} />;
      } else {
        if (classNameLabel == "Funded") {
          return <CircleIcon color="disabled" sx={{ size: 2 }} />;
        }
        return <CircleIcon color="primary" sx={{ size: 2 }} />;
      }
    } else if (
      classNameLabel == "New" ||
      classNameLabel == "restart" ||
      classNameLabel == "Initial Review"
    ) {
      if (isWaitProcess == "yes") {
        return <CircleIcon color="warning" sx={{ size: 2 }} />;
      } else {
        return <CircleIcon color="primary" sx={{ size: 2 }} />;
      }
    } else {
      return <CircleIcon color="primary" sx={{ size: 2 }} />;
    }
  } else {
    return <CircleIcon sx={{ color: "white", size: 2 }} />;
  }
}

const CustomerStepper = styled(Stepper)(({ theme }) => ({
  "& .MuiStepConnector-horizontal:first .MuiStepConnector-lineHorizontal": {
    borderStyle: "dotted",
    borderColor: "red",
    borderTop: "none",
  },
}));

const ApplicationStatusField = ({ ...props }) => {
  const { activeStatus, appId, record } = props;
  let isWaitProcess = props.isWaitProcess;
  let activeStatus2 = activeStatus;
  // console.log("ApplicationStatusField activeStatus 1111==>", activeStatus2);
  if (
    activeStatus2 == "Completed" ||
    activeStatus2 == "Approved" ||
    activeStatus2 == "Declined"
  ) {
    activeStatus2 = "Close";
  } else if (activeStatus2 == "Countered" || activeStatus2 == "Pre-Approved") {
    activeStatus2 = "To Notify";
    if (record.sApplicationResponse != "Accept") {
      isWaitProcess = "yes";
    }
  } else if (activeStatus2 == "Expired") {
    activeStatus2 = "To Notify";
  } else if (activeStatus2 == "Hold") {
    activeStatus2 = "New";
  } else if (activeStatus2 == "Funded") {
    activeStatus2 = "Funded";
  } else if (activeStatus2 == "restart") {
    activeStatus2 = "Initial Review";
  }
  //{{{ Check Disbursement Status
  if (
    activeStatus2 == "Close" &&
    (record?.attachAttrs?.executeStatus == "Closing Docs Received" ||
      record?.attachAttrs?.executeStatus == "Closing Dos Received")
  ) {
    //       All applications with “Ready for Disbursement” status should have the Disbursement bubble colored:
    // gray - completed, Off-Line (Blue Complete button on bottom)
    // Blue - Pending, In-Progress (No Complete button on bottom)
    // Orange - Failed, Error (No Complete button on bottom)
    activeStatus2 = "Funded";
    if (
      record?.sDisbursementPayment == "NO_ACH" ||
      record?.sDisbursementPayment == "MANUAL_ACH"
    ) {
      isWaitProcess = "no"; //gray
    }
    if (record?.disbursementStatus) {
      if (
        record?.disbursementStatus == "success" ||
        record?.disbursementStatus == "succeed" ||
        record?.disbursementStatus == "processed"
      ) {
        isWaitProcess = "no"; //gray
      } else if (
        record?.disbursementStatus == "executing" ||
        record?.disbursementStatus == "start"
      ) {
        isWaitProcess = "executing"; //blue
      } else if (record?.disbursementStatus?.includes("Failed")) {
        isWaitProcess = "yes"; //orange
      } else if (
        record?.disbursementStatus == "canceled" ||
        record?.disbursementStatus == "disabled"
      ) {
        isWaitProcess = "yes"; //orange
      }
    }
  }
  //}}} end Check Disbursement Status
  // console.log(
  //   "ApplicationStatusField activeStatus 2222==>",
  //   isWaitProcess
  // );
  const AppStatusStepNum = activeStatus2 ? steps.indexOf(activeStatus2) : 0;

  return (
    <Box sx={{ width: "100%", height: "120px" }}>
      <CustomerStepper activeStep={AppStatusStepNum} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={ColorlibStepIcon}
              StepIconProps={{ className: label + "/" + isWaitProcess }}
              error={
                label == "Close" && activeStatus == "Declined"
                  ? true
                  : false || (label == "To Notify" && activeStatus == "Expired")
                  ? true
                  : false
              }
            >
              {/* [ {label} - {isWaitProcess} - {appId} ] */}
              {label == "Funded" && "Disbursement"}
              {label == "Close" && "Closing"}
              {label == "To Notify" && "Notification"}
              {label != "Completed" &&
                label != "Close" &&
                label != "Funded" &&
                label != "To Notify" &&
                label}
            </StepLabel>
          </Step>
        ))}
      </CustomerStepper>
    </Box>
  );
};

export default ApplicationStatusField;
